<template>
  <div class="scroll-down-container" v-show="showButton" @click="scrollToBottom">
    <div class="scroll-down-button">
      <button
      class="bg-hover03 btn-2 iconButton button-root button_variant-tertiary button_size-default rounded-circle button_variant_icon"
      type="button"
    >
      <!-- 替换 mdi-icon 为你的 SVG 图标 -->
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 10L12 15L17 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScrollDownButton',
  data() {
    return {
      showButton: false,
      scrollThreshold: -10, // 滚动超过这个距离才显示按钮
      bottomThreshold: 200, // 距离底部这个距离内不显示按钮
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 当滚动位置超过阈值且没有接近底部时显示按钮
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      
      this.showButton = scrollTop > this.scrollThreshold && 
                       (scrollHeight - scrollTop - clientHeight) > this.bottomThreshold;
    },
    scrollToBottom() {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style scoped>
.scroll-down-container {
  position: absolute;
  bottom: 150px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  cursor: pointer;
}

.scroll-down-button {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.scroll-down-button:hover {
  transform: translateY(2px);
}
</style>